export default [
  {
    type: 'line',
    data: {
      labels: '',
      datasets: [
        {
          data: [],
          borderWidth: 1,
          backgroundColor: '#fff',
          borderColor: '#fff',
          fill: false,
          showLines: true,
        },
      ],
    },
    options: {
      animation: false,
      tooltips: {
        callbacks: {
          label: function(tooltipItems) {
            return tooltipItems.yLabel + '%'
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      maintainAspectRatio: false,

      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: '',
              displayFormats: {
                day: 'M/D',
                month: 'YYYY-MM',
              },
            },
            ticks: {
              source: 'labels',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 10,
            },
          },
        ],
      },
    },
  },
  {
    type: 'bar',
    data: {
      labels: '',
      datasets: [
        {
          data: [],
          borderWidth: 1,
          backgroundColor: '#fff',
          borderColor: '#fff',
          fill: false,
        },
      ],
    },
    options: {
      animation: false,
      tooltips: {
        callbacks: {
          label: function(tooltipItems) {
            return tooltipItems.yLabel + '人'
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: '',
              displayFormats: {
                day: 'M/D',
                month: 'YYYY-MM',
              },
            },
            ticks: {
              source: 'labels',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 10,
            },
          },
        ],
      },
    },
  },
  {
    type: 'bar',
    data: {
      labels: '',
      datasets: [
        {
          data: [],
          borderWidth: 1,
          backgroundColor: '#fff',
          borderColor: '#fff',
          fill: false,
        },
      ],
    },
    options: {
      animation: false,
      tooltips: {
        callbacks: {
          label: function(tooltipItems) {
            return tooltipItems.yLabel + '件'
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: '',
              displayFormats: {
                day: 'M/D',
                month: 'YYYY-MM',
              },
            },
            ticks: {
              source: 'labels',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 10,
            },
          },
        ],
      },
    },
  },
]
